import '.ep{line-height:1.375rem;}.ssr-plugin'
import '.bk{font-size:0.875rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.eq{gap:0.38rem;}.ssr-plugin'
import '.er{padding:0.5rem 1rem;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import '.a5{flex-grow:1;}.ssr-plugin'
import '.es{padding:0px;}.ssr-plugin'
import '.bi{border:none;}.ssr-plugin'
import '.et{outline:none;}.ssr-plugin'
import '.da{background:transparent;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  KeyboardEvent,
  MutableRefObject,
  forwardRef,
  FocusEventHandler,
  KeyboardEventHandler,
} from 'react'
import { Text } from '../../typography/Text'

export type TextInputProps = {
  text: string
  placeholder?: string
  label?: string
  errorMessage?: string
  style?: Style
  ref?: MutableRefObject<HTMLInputElement>
  setText: (text: string) => void
  onBlur?: FocusEventHandler<HTMLInputElement>
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
}

export const BorderlessTextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      text,
      placeholder,
      label,
      errorMessage,
      style,
      setText,
      onBlur,
      onKeyDown,
    }: TextInputProps,
    ref,
  ) => {
    const errorStateOn = !!errorMessage
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
      if (onKeyDown) {
        onKeyDown(event)
      }
    }

    return (
      <styled.div className="ep bk a e ae eq er"
        style={{
          '&:has(:disabled)': {
            cursor: 'not-allowed',
          },
          ...style,
        }}
      >
        <div className="a f an"
          style={{
            background: errorStateOn
              ? 'var(--palette-red-100)'
              : 'var(--palette-white)',
          }}
        >
          {label && <styled.div>{label}</styled.div>}
          <styled.input className="a5 es bi et da"
            placeholder={placeholder}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onBlur={onBlur}
            onKeyDown={handleKeyDown}
            ref={ref}
            style={{
              '&::placeholder': {
                color: errorStateOn
                  ? 'var(--palette-red-400)'
                  : 'var(--gray-300)',
                userSelect: 'none',
              },
              '&:disabled': {
                cursor: 'not-allowed',
              },
            }}
          ></styled.input>
        </div>
        {errorStateOn && (
          <Text.ExtraSmall style={{ color: 'var(--palette-red-600)' }}>
            {errorMessage}
          </Text.ExtraSmall>
        )}
      </styled.div>
    )
  },
)

BorderlessTextInput.displayName = 'BorderlessTextInput'
